import {createContext, ReactElement, ReactNode} from "react";
import {
  FieldErrors,
  FieldValues,
  useForm,
  UseFormProps,
  UseFormReturn,
} from "react-hook-form";

import {ErrorMessage} from "@/components/ErrorMessage/ErrorMessage";

export type HookFormContextType<T extends FieldValues = any> =
  UseFormReturn<T> & {
    printError: (
      name: string,
      error: FieldErrors<any>
    ) => ReactElement | undefined;
  };

export const HookFormContext = createContext<HookFormContextType | null>(null);

export function HookFormContextProvider<T extends FieldValues>({
  children,
  defaultValues,
}: {
  children: ReactNode;
  defaultValues?: UseFormProps<T>["defaultValues"];
}): ReactElement {
  const methode = useForm<T>({
    mode: "onChange",
    defaultValues,
    shouldFocusError: true,
  });
  // Récupère une valeur imbriquée dans un objet à partir d'un chemin en string (ex: "user.profile.name").
  const getFormData = (obj: any, path: string): any => {
    return path.split(".").reduce((acc, part) => acc?.[part], obj);
  };

  const printError = (
    name: string,
    errors: FieldErrors<any>
  ): ReactElement | undefined => {
    const error = getFormData(errors, name);

    if (error) {
      return <ErrorMessage text={error.toString()} />;
    }
  };
  return (
    <HookFormContext.Provider value={{...methode, printError}}>
      {children}
    </HookFormContext.Provider>
  );
}
